import { ComponentProps, forwardRef } from 'react';
import { TextField, Label, TextAreaProps } from 'react-aria-components';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';

type TextAreaInputProps = TextAreaProps & {
  name: string;
  label?: string;
  placeholder?: string;
  supportText?: string;
  required?: boolean;
  disabled?: boolean;
  register?: UseFormRegisterReturn;
  errors?: FieldError | undefined;
  rows?: number;
};

type ChildProps = ComponentProps<'textarea'> & TextAreaInputProps;

const TextAreaInput = forwardRef<HTMLTextAreaElement, ChildProps>(
  (
    {
      name,
      label,
      placeholder,
      supportText,
      required,
      disabled,
      register,
      errors,
      rows = 4,
      ...rest
    },
    ref
  ) => {
    return (
      <TextField
        aria-label={`${name}-TextArea`}
        name={name}
        isRequired={required}
        isDisabled={disabled}
        className="flex w-full flex-col"
      >
        {label && (
          <div className="flex flex-row items-center">
            <Label className="mb-2 text-lg font-bold">{label}</Label>
            {required && <span className="mb-2 ml-1 text-red-800">※必須</span>}
          </div>
        )}
        {supportText && <span className="mb-2 text-sm text-gray-500">{supportText}</span>}
        <textarea
          name={name}
          disabled={disabled}
          className="mb-2 block rounded-md border border-[#1A1A1A] px-3 py-2 focus:border-2 focus:border-yellow-700 disabled:border-solid-gray-420 disabled:bg-solid-gray-50 disabled:text-solid-gray-420 sm:text-sm"
          placeholder={placeholder}
          rows={rows}
          ref={ref}
          {...register}
          {...rest}
        />
        <div className="mb-2 w-fit text-sm text-red-800">{errors?.message}</div>
      </TextField>
    );
  }
);

TextAreaInput.displayName = 'TextAreaInput';

export default TextAreaInput;
